import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import { Logger } from "./../logger/Logger";

export default class BottomLeftTip extends React.Component {
  static propTypes = {
    message: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    dismissDelay: PropTypes.number.isRequired
  }
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.timerId = setTimeout(() => {
      window.gs.bottomLeftTip = null;
      window.render();
    }, this.props.dismissDelay > 0 ? this.props.dismissDelay : 5000);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.message !== nextProps.message) {
      //clearTimeout(this.timerId);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timerId);
  }



  onClick = (event) => {
    if (this.props.onClick) {
      this.props.onClick();
    }
    clearTimeout(this.timerId);
    window.gs.bottomLeftTip = null;
    window.render();
  }

  render() {
    return (
      <div style={styles.tipStyle} onClick={this.onClick}>
        {this.props.message}
      </div>
    );
  }


}

const styles = {
  tipStyle: {    
    zIndex: 100,
    position: 'fixed',
    bottom: '10px',
    right: '10px',
    fontSize: '13px',
    padding: '9px 15px',
    backgroundColor: 'rgb(235, 106, 92)',
    color: '#fff',
    fontWeight:600
  }
};